<template>
  <b-button class="add-button" :variant="'primary'">
    <div class="d-flex align-items-center">
      <icon-transfer class="mr-2" />
      <span>{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";
import { computed } from "@vue/composition-api";
import IconTransfer from "@/@core/components/svg/common/IconTransfer.vue";

export default {
  components: {
    BButton,
    IconTransfer,
  },
  props: {
    btnLabel: { type: String },
  },
  setup(props) {
    return {
      
    };
  },
};
</script>

<style scoped>
.add-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  font-size: 20px;
  width: 100px;
}

.add-button svg {
  width: 18px;
  fill: var(--button-primary-font);
}
</style>
